module.exports = __webpack_public_path__ + "img/Lindsay Cherry, 1956.6d1b8b6a.jpg";